module.exports = __webpack_public_path__ + "img/app-sumo-logo.ce93ff03.png";